<template>
	<v-snackbar :timeout="0" v-model="value" top color="gradiente">
		{{ text }}
		<v-icon>info</v-icon>
	</v-snackbar>
</template>

<script>
	import { setTimeout } from "timers";
	export default {
		props: ["value", "text"],
		watch: {
			value() {
				if (this.value) {
					var v = this;
					setTimeout(() => {
						v.close();
					}, 3000);
				}
			}
		},
		methods: {
			close() {
				this.$emit("input", !this.value);
			}
		}
	};
</script>

<style>
</style>
